import script from "./CasillaPrivacidad.vue?vue&type=script&setup=true&lang=ts"
export * from "./CasillaPrivacidad.vue?vue&type=script&setup=true&lang=ts"

import "./CasillaPrivacidad.vue?vue&type=style&index=0&id=a2e3674e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2e3674e"]])

export default __exports__